import { atom } from 'jotai'
import { TProduct } from '../types/product.types'

export const renewalProductsState = atom<TProduct[]>([])
